import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import { ArrowRight } from "lucide-react";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, light = false }) => (
  <p className={`font-mono text-xs md:text-sm tracking-[0.2em] uppercase mb-4 ${light ? "text-[#29CC9A]" : "text-[#215389]"}`}>
    {children}
  </p>
);

export const SectionHead = ({ overline, title, light = false, className = "" }) => (
  <Reveal className={className}>
    <Overline light={light}>{overline}</Overline>
    <h2 className={`font-heading text-3xl md:text-5xl font-bold tracking-tight ${light ? "text-white" : "text-[#0A121F]"}`}>
      {title}
    </h2>
  </Reveal>
);

const RIBBON_ITEMS = [
  "Factory Direct — No Middleman",
  "In-House Powder Coating",
  "Comar · Senior · Exlabesa Systems",
  "Any RAL Colour — Paramount Powders",
  "Fabricated in Romford",
  "Fast, Clear Lead Times",
  "Unbeatable Trade Prices",
  "The Tradesman's Choice",
];

export const Ribbon = () => (
  <div className="bg-[#215389] py-4 overflow-hidden" data-testid="marquee-ribbon">
    <Marquee speed={40} gradient={false} autoFill>
      {RIBBON_ITEMS.map((t) => (
        <span key={t} className="flex items-center font-mono text-xs md:text-sm tracking-[0.2em] uppercase text-white mx-6">
          {t} <span className="ml-12 text-[#29CC9A]">◆</span>
        </span>
      ))}
    </Marquee>
  </div>
);

export const CTABand = ({ title = "Ready to price your project?", subtitle = "Send us your sizes today — quotes back within 24 hours, factory-direct prices guaranteed." }) => (
  <section className="bg-[#215389] relative overflow-hidden" data-testid="cta-band">
    <div className="absolute -right-20 -top-20 w-96 h-96 rounded-full bg-[#29CC9A]/10" aria-hidden="true" />
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 relative">
      <Reveal>
        <h2 className="font-heading text-3xl md:text-5xl font-bold tracking-tight text-white max-w-2xl">{title}</h2>
        <p className="mt-5 text-base md:text-lg text-slate-200 max-w-xl">{subtitle}</p>
        <div className="mt-9 flex flex-wrap gap-4">
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-[#29CC9A] text-[#0A121F] font-bold rounded-full hover:bg-[#22b487] transition-colors duration-300"
            data-testid="cta-band-quote-btn"
          >
            Get a Free Quote <ArrowRight size={17} />
          </Link>
          <Link
            to="/products"
            className="inline-flex items-center gap-2 px-7 py-3.5 border border-white/30 text-white font-bold rounded-full hover:bg-white/10 transition-colors duration-300"
            data-testid="cta-band-products-btn"
          >
            Browse Products
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
